import React, { useEffect, useState } from 'react';

export default function SplashScreen({ onComplete }) {
  const [phase, setPhase] = useState(0);

  useEffect(() => {
    const timers = [
      setTimeout(() => setPhase(1), 100),   // horizontal line
      setTimeout(() => setPhase(2), 400),   // wordmark staggers in
      setTimeout(() => setPhase(3), 600),   // line fades out
      setTimeout(() => setPhase(4), 800),   // accent gradient line
      setTimeout(() => setPhase(5), 1800),  // curtain lift
      setTimeout(() => onComplete(), 2700), // done
    ];
    return () => timers.forEach(clearTimeout);
  }, [onComplete]);

  const lifting = phase >= 5;

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 9999,
      background: '#020408',
      pointerEvents: lifting ? 'none' : 'auto',
      transform: lifting ? 'translateY(-100%)' : 'translateY(0)',
      transition: lifting ? 'transform 900ms cubic-bezier(0.77, 0, 0.175, 1)' : 'none',
      willChange: 'transform',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
    }}>
      <div style={{
        display: 'flex', flexDirection: 'column', alignItems: 'center',
        position: 'relative',
      }}>
        {/* Horizontal line */}
        <div style={{
          position: 'absolute', top: '50%', left: '50%',
          height: '1px',
          width: phase >= 1 ? '120px' : '0px',
          transform: 'translate(-50%, -50%)',
          background: 'rgba(255,255,255,0.15)',
          opacity: phase >= 3 ? 0 : 1,
          transition: phase >= 3
            ? 'opacity 400ms ease'
            : 'width 300ms cubic-bezier(0.25, 0.46, 0.45, 0.94)',
        }} />

        {/* MANE wordmark */}
        <div style={{
          display: 'flex',
          fontFamily: "'Inter', -apple-system, sans-serif",
          fontSize: '16px', fontWeight: 600,
          letterSpacing: '0.5em', textTransform: 'uppercase',
        }}>
          {['M', 'A', 'N', 'E'].map((letter, i) => (
            <span key={letter} style={{
              color: '#fff',
              opacity: phase >= 2 ? 1 : 0,
              transform: phase >= 2 ? 'translateY(0)' : 'translateY(8px)',
              transition: `opacity 350ms ease ${i * 50}ms, transform 350ms cubic-bezier(0.16, 1, 0.3, 1) ${i * 50}ms`,
              display: 'inline-block',
            }}>
              {letter}
            </span>
          ))}
        </div>

        {/* Accent gradient line */}
        <div style={{
          width: phase >= 4 ? '40px' : '0px',
          height: '1px',
          marginTop: '14px',
          background: 'linear-gradient(90deg, #2B7FFF, #C9A84C)',
          transition: 'width 400ms cubic-bezier(0.16, 1, 0.3, 1)',
        }} />
      </div>
    </div>
  );
}
